/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestionsFeedRendererQueryVariables = {
    debugFetchDate?: unknown | null | undefined;
};
export type SuggestionsFeedRendererQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"SuggestionsFeed_viewer">;
    };
};
export type SuggestionsFeedRendererQuery = {
    readonly response: SuggestionsFeedRendererQueryResponse;
    readonly variables: SuggestionsFeedRendererQueryVariables;
};



/*
query SuggestionsFeedRendererQuery(
  $debugFetchDate: BigInt
) {
  viewer {
    ...SuggestionsFeed_viewer_2ILGSp
    id
  }
}

fragment AvatarPerson_org on Org {
  id
}

fragment AvatarPerson_person on Person {
  __typename
  id
  emails
  primaryEmail
  isYou
  userId
  isUser
  profile {
    givenName
    familyName
    externalImageUrl
  }
}

fragment AvatarRow_org on Org {
  ...AvatarPerson_org
}

fragment AvatarRow_personList on PersonList {
  list {
    ...AvatarPerson_person
    primaryEmail
    id
  }
}

fragment SuggestionActionAutopilot_org on Org {
  id
}

fragment SuggestionActionAutopilot_payload on SuggestionActionAutopilotPayload {
  externalEventId
  calendarId
  hasRoom
}

fragment SuggestionActionColors_org on Org {
  id
  primaryOrgCalendar
  eventColoringSettingsErrorable {
    __typename
    ... on EventColoringSettings {
      eventCategoryColorings {
        eventCategory
        googleColorKey
        active
        isUserSet
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment SuggestionActionConfigSettings_org on Org {
  ...SuggestionActionColors_org
  ...SuggestionActionSlack_org
  ...SuggestionActionTravelTime_org
}

fragment SuggestionActionConfigSettings_payload on SuggestionActionConfigureSettingsPayload {
  configureSettingsType
}

fragment SuggestionActionDecline_payload on SuggestionActionDeclinePayload {
  nop
}

fragment SuggestionActionFyi_payload on SuggestionActionFyiPayload {
  nop
}

fragment SuggestionActionInvite_org on Org {
  id
}

fragment SuggestionActionInvite_payload on SuggestionActionInvitePayload {
  calendarId
}

fragment SuggestionActionRemoveAttendee_payload on SuggestionActionRemoveAttendeePayload {
  nop
}

fragment SuggestionActionRequestToMove_payload on SuggestionActionRequestToMovePayload {
  betterTime {
    date
    timeSlot
  }
  nearestAlternateTime {
    date
    timeSlot
  }
}

fragment SuggestionActionReschedule_payload on SuggestionActionReschedulePayload {
  calendarId
  externalEventId
  betterTime {
    date
    timeSlot
  }
  nearestAlternateTime {
    date
    timeSlot
  }
  eventStartWeek
  event {
    calendarIds
    isAllDay
    eventKey {
      externalEventId
      id
    }
    startTime {
      millis
      dateOrDateTime
      timeZone
    }
    endTime {
      millis
    }
    title
    attendees {
      displayName
      urnValue
    }
    organizer {
      urnValue
    }
  }
}

fragment SuggestionActionSlack_org on Org {
  id
  slackAccountsErrorable {
    __typename
    ... on SlackAccountList {
      list {
        slackTeamId
        slackUserId
        teamDisplayName
        id
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  slackSettingsErrorable {
    __typename
    ... on SlackSettingsList {
      list {
        id
        slackTeamId
        slackUserId
        calendarStatus {
          calendarStatusEnabled
          includeMeetingCategory
          includeMeetingTitle
        }
        dailyDigestSettings {
          enabled
          timeSlot
        }
        dndSettings {
          focusTime
          meeting
        }
        notificationSettings {
          defragSummary
        }
        calendarStatusEnabled
        includeMeetingCategory
        includeMeetingTitle
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment SuggestionActionTravelTime_org on Org {
  id
  workAddressForUser {
    __typename
    ... on Address {
      rawAddress
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
}

fragment SuggestionActionViewMeeting_payload on SuggestionActionViewMeetingPayload {
  externalEventId
  calendarId
}

fragment SuggestionActionViewProfile_payload on SuggestionActionViewProfilePayload {
  calendarId
  viewWeek
}

fragment SuggestionActionViewTeamDashboard_payload on SuggestionActionViewTeamDashboardPayload {
  __typename
}

fragment SuggestionAction_feedSuggestion on FeedSuggestion {
  id
  suggestionPayload {
    __typename
    ... on SuggestionResultChromeExtensionTipPayload {
      tipType
    }
    ... on SuggestionResultMissingUserConfigurationPayload {
      configurationType
    }
  }
  primaryAction {
    display
    isPrimary
    type
    payload {
      __typename
      ... on SuggestionActionAutopilotPayload {
        ...SuggestionActionAutopilot_payload
      }
      ... on SuggestionActionConfigureSettingsPayload {
        ...SuggestionActionConfigSettings_payload
      }
      ... on SuggestionActionDeclinePayload {
        ...SuggestionActionDecline_payload
      }
      ... on SuggestionActionFyiPayload {
        ...SuggestionActionFyi_payload
      }
      ... on SuggestionActionInvitePayload {
        ...SuggestionActionInvite_payload
      }
      ... on SuggestionActionRemoveAttendeePayload {
        ...SuggestionActionRemoveAttendee_payload
      }
      ... on SuggestionActionRequestToMovePayload {
        ...SuggestionActionRequestToMove_payload
      }
      ... on SuggestionActionReschedulePayload {
        ...SuggestionActionReschedule_payload
      }
      ... on SuggestionActionViewMeetingPayload {
        ...SuggestionActionViewMeeting_payload
      }
      ... on SuggestionActionViewProfilePayload {
        ...SuggestionActionViewProfile_payload
      }
      ... on SuggestionActionViewTeamDashboardPayload {
        ...SuggestionActionViewTeamDashboard_payload
      }
    }
  }
}

fragment SuggestionAction_org on Org {
  ...SuggestionActionInvite_org
  ...SuggestionActionAutopilot_org
  ...SuggestionActionConfigSettings_org
  experiments
}

fragment SuggestionBodyAutopilot_org on Org {
  ...AvatarPerson_org
  id
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      list {
        ...AvatarPerson_person
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment SuggestionBodyAutopilot_suggestionPayload on SuggestionResultPayload {
  __isSuggestionResultPayload: __typename
  ... on SuggestionResultMeetingNotOnAutopilotPayload {
    targetEvent {
      title
      attendees {
        urnValue
        displayName
      }
      recurrenceRules {
        firstInstanceStartTime {
          type
          dateOrDateTime
          timeZone
          millis
          offsetMinutes
        }
        timeZone
        interval {
          interval
          byDay
          bySetPos
          freqType
          count
          untilTime {
            type
            dateOrDateTime
            timeZone
            millis
            offsetMinutes
          }
        }
      }
      startTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
      endTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
}

fragment SuggestionBodyConfigColors_org on Org {
  eventColoringSettingsErrorable {
    __typename
    ... on EventColoringSettings {
      eventCategoryColorings {
        googleColorKey
        eventCategory
        active
        isUserSet
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment SuggestionBodyConflictingMeeting_org on Org {
  id
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment SuggestionBodyConflictingMeeting_suggestionPayload on SuggestionResultPayload {
  __isSuggestionResultPayload: __typename
  ... on SuggestionResultConflictingMeetingPayload {
    targetEvent {
      title
      organizer {
        urnValue
      }
      createdMillis
      startTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
      endTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
    conflictingEvent {
      title
      createdMillis
      organizer {
        urnValue
      }
      startTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
      endTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
}

fragment SuggestionBodyExpensiveMeeting_org on Org {
  ...AvatarRow_org
  id
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      ...AvatarRow_personList
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment SuggestionBodyExpensiveMeeting_suggestionPayload on SuggestionResultPayload {
  __isSuggestionResultPayload: __typename
  ... on SuggestionResultExpensiveMeetingPayload {
    focusMinutesCost
    targetEvent {
      title
      calendarIds
      organizer {
        urnValue
      }
      createdMillis
      startTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
      endTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
}

fragment SuggestionBodyExpensiveOrganizer_org on Org {
  ...AvatarPerson_org
  id
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      list {
        ...AvatarPerson_person
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment SuggestionBodyExpensiveOrganizer_suggestionPayload on SuggestionResultPayload {
  __isSuggestionResultPayload: __typename
  ... on SuggestionResultExpensiveOrganizerPayload {
    approximateMonthlyFocusHoursCost
    calendarId
  }
}

fragment SuggestionBodyLowFocusTime_org on Org {
  ...AvatarPerson_org
  id
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      list {
        ...AvatarPerson_person
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment SuggestionBodyLowFocusTime_suggestionPayload on SuggestionResultLowFocusTimePayload {
  calendarId
  totalFocusTimeMinutes
  totalMinutes
  week
}

fragment SuggestionBodyOutOfOffice_org on Org {
  id
  ...AvatarPerson_org
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      list {
        ...AvatarPerson_person
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment SuggestionBodyOutOfOffice_suggestionPayload on SuggestionResultPayload {
  __isSuggestionResultPayload: __typename
  ... on SuggestionResultTeammateOutOfOfficePayload {
    calendarId
    minDate
    maxDate
    targetEvent {
      title
    }
  }
}

fragment SuggestionBodyWeekInReview_suggestionPayload on SuggestionResultPayload {
  __isSuggestionResultPayload: __typename
  ... on SuggestionResultWeekInReviewPayload {
    rewindHistory {
      ...WeekInReviewScrubber_rewindHistory
      id
    }
    rewindWeek
  }
}

fragment SuggestionBodyWeeklyAutopilotSummary_org on Org {
  ...AvatarRow_org
  id
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      ...AvatarRow_personList
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment SuggestionBodyWeeklyAutopilotSummary_suggestionPayload on SuggestionResultPayload {
  __isSuggestionResultPayload: __typename
  ... on SuggestionResultWeeklyAutopilotSummaryPayload {
    historicalDefragBenefitScore {
      totalFocusTimeSavings
      conflictsResolved
      affectedCalendars
      meetingsMoved
    }
    dateRangeMin
    dateRangeMax
  }
}

fragment SuggestionBody_org on Org {
  ...SuggestionBodyAutopilot_org
  ...SuggestionBodyConfigColors_org
  ...SuggestionBodyConflictingMeeting_org
  ...SuggestionBodyExpensiveMeeting_org
  ...SuggestionBodyExpensiveOrganizer_org
  ...SuggestionBodyLowFocusTime_org
  ...SuggestionBodyOutOfOffice_org
  ...SuggestionBodyWeeklyAutopilotSummary_org
}

fragment SuggestionBody_suggestionPayload on SuggestionResultPayload {
  __isSuggestionResultPayload: __typename
  __typename
  ...SuggestionBodyAutopilot_suggestionPayload
  ...SuggestionBodyConflictingMeeting_suggestionPayload
  ...SuggestionBodyExpensiveMeeting_suggestionPayload
  ...SuggestionBodyExpensiveOrganizer_suggestionPayload
  ...SuggestionBodyLowFocusTime_suggestionPayload
  ...SuggestionBodyOutOfOffice_suggestionPayload
  ...SuggestionBodyWeekInReview_suggestionPayload
  ...SuggestionBodyWeeklyAutopilotSummary_suggestionPayload
  ... on SuggestionResultChromeExtensionTipPayload {
    tipType
  }
  ... on SuggestionResultMissingUserConfigurationPayload {
    configurationType
  }
}

fragment SuggestionCardHeader_feedSuggestion on FeedSuggestion {
  occurredMillis
  suggestionId
  suggestionType
  text {
    title
    subHeading
  }
  suggestionPayload {
    __typename
    ... on SuggestionResultChromeExtensionTipPayload {
      tipType
    }
    ... on SuggestionResultMissingUserConfigurationPayload {
      configurationType
    }
  }
}

fragment SuggestionCardHeader_org on Org {
  experiments
  primaryTeam {
    __typename
    ... on Team {
      teamName
    }
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment SuggestionCard_feedSuggestion on FeedSuggestion {
  ...SuggestionAction_feedSuggestion
  ...SuggestionCardHeader_feedSuggestion
  id
  suggestionId
  suggestionType
  suggestionPayload {
    ...SuggestionBody_suggestionPayload
    __typename
    ... on SuggestionResultChromeExtensionTipPayload {
      tipType
    }
    ... on SuggestionResultMissingUserConfigurationPayload {
      configurationType
    }
  }
  primaryAction {
    type
  }
}

fragment SuggestionCard_org on Org {
  ...SuggestionAction_org
  ...SuggestionBody_org
  ...SuggestionCardHeader_org
}

fragment SuggestionsFeed_viewer_2ILGSp on Viewer {
  user {
    orgs(first: 1000000) {
      edges {
        node {
          ...SuggestionCard_org
          experiments
          feedSuggestionsErrorable(debugFetchDate: $debugFetchDate) {
            __typename
            ... on GraphEntityError {
              statusCode
              message
            }
            ... on FeedSuggestionResults {
              suggestions {
                id
                occurredMillis
                suggestionType
                ...SuggestionCard_feedSuggestion
                suggestionPayload {
                  __typename
                  ... on SuggestionResultChromeExtensionTipPayload {
                    tipType
                  }
                  ... on SuggestionResultMissingUserConfigurationPayload {
                    configurationType
                  }
                }
              }
            }
          }
          id
        }
      }
    }
    id
  }
}

fragment WeekInReviewScrubber_rewindHistory on RewindHistory {
  id
  snapshotDurationMillis
  snapshots {
    snapshotMillis
    days {
      workingHours {
        amBits
        pmBits
      }
      meetings {
        amBits
        pmBits
      }
      focusTime {
        amBits
        pmBits
      }
      lunch {
        amBits
        pmBits
      }
      fragmented {
        amBits
        pmBits
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "debugFetchDate"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "debugFetchDate",
            "variableName": "debugFetchDate"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v4 = {
        "kind": "InlineFragment",
        "selections": [
            (v2 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slackTeamId",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slackUserId",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v9 = {
        "kind": "InlineFragment",
        "selections": [
            (v7 /*: any*/),
            (v8 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarStatusEnabled",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "includeMeetingCategory",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "includeMeetingTitle",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeSlot",
        "storageKey": null
    } as any, v14 = {
        "kind": "InlineFragment",
        "selections": [
            (v8 /*: any*/),
            (v7 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dateOrDateTime",
        "storageKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "millis",
        "storageKey": null
    } as any, v22 = [
        (v18 /*: any*/),
        (v19 /*: any*/),
        (v20 /*: any*/),
        (v21 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offsetMinutes",
            "storageKey": null
        } as any
    ], v23 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "startTime",
        "plural": false,
        "selections": (v22 /*: any*/),
        "storageKey": null
    } as any, v24 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "endTime",
        "plural": false,
        "selections": (v22 /*: any*/),
        "storageKey": null
    } as any, v25 = {
        "alias": null,
        "args": null,
        "concreteType": "Attendee",
        "kind": "LinkedField",
        "name": "organizer",
        "plural": false,
        "selections": [
            (v16 /*: any*/)
        ],
        "storageKey": null
    } as any, v26 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdMillis",
        "storageKey": null
    } as any, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarIds",
        "storageKey": null
    } as any, v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarId",
        "storageKey": null
    } as any, v29 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amBits",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pmBits",
            "storageKey": null
        } as any
    ], v30 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v31 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nop",
            "storageKey": null
        } as any
    ], v32 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
        } as any,
        (v13 /*: any*/)
    ], v33 = {
        "alias": null,
        "args": null,
        "concreteType": "DayTimeSlot",
        "kind": "LinkedField",
        "name": "betterTime",
        "plural": false,
        "selections": (v32 /*: any*/),
        "storageKey": null
    } as any, v34 = {
        "alias": null,
        "args": null,
        "concreteType": "DayTimeSlot",
        "kind": "LinkedField",
        "name": "nearestAlternateTime",
        "plural": false,
        "selections": (v32 /*: any*/),
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SuggestionsFeedRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": (v1 /*: any*/),
                            "kind": "FragmentSpread",
                            "name": "SuggestionsFeed_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SuggestionsFeedRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1000000
                                        }
                                    ],
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgCalendar",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "eventColoringSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "EventCategoryColoring",
                                                                            "kind": "LinkedField",
                                                                            "name": "eventCategoryColorings",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "eventCategory",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "googleColorKey",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "active",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isUserSet",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "EventColoringSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v4 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "slackAccountsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SlackAccount",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v5 /*: any*/),
                                                                                (v6 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "teamDisplayName",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v2 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SlackAccountList",
                                                                    "abstractKey": null
                                                                },
                                                                (v9 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "slackSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SlackSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v5 /*: any*/),
                                                                                (v6 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SlackCalendarStatusSync",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "calendarStatus",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v10 /*: any*/),
                                                                                        (v11 /*: any*/),
                                                                                        (v12 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SlackDailyDigestSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "dailyDigestSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "enabled",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v13 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SlackDndSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "dndSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "focusTime",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "meeting",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SlackNotificationSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "notificationSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defragSummary",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v10 /*: any*/),
                                                                                (v11 /*: any*/),
                                                                                (v12 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SlackSettingsList",
                                                                    "abstractKey": null
                                                                },
                                                                (v14 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "workAddressForUser",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "rawAddress",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "Address",
                                                                    "abstractKey": null
                                                                },
                                                                (v9 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "experiments",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "calendarIds",
                                                                    "value": []
                                                                }
                                                            ],
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "personsByCalendarIdsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Person",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v3 /*: any*/),
                                                                                (v2 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "emails",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "primaryEmail",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isYou",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "userId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isUser",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "UserProfile",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "profile",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "givenName",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "familyName",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "externalImageUrl",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "PersonList",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v7 /*: any*/)
                                                                    ],
                                                                    "type": "GraphEntityError",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": "personsByCalendarIdsErrorable(calendarIds:[])"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "primaryTeam",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "teamName",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "Team",
                                                                    "abstractKey": null
                                                                },
                                                                (v14 /*: any*/),
                                                                (v4 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v1 /*: any*/),
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "feedSuggestionsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                (v14 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "FeedSuggestion",
                                                                            "kind": "LinkedField",
                                                                            "name": "suggestions",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "occurredMillis",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "suggestionType",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "suggestionPayload",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v3 /*: any*/),
                                                                                        {
                                                                                            "kind": "TypeDiscriminator",
                                                                                            "abstractKey": "__isSuggestionResultPayload"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "tipType",
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SuggestionResultChromeExtensionTipPayload",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "configurationType",
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SuggestionResultMissingUserConfigurationPayload",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Event",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "targetEvent",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v15 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "Attendee",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "attendees",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                (v16 /*: any*/),
                                                                                                                (v17 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "RecurrenceRules",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "recurrenceRules",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "EventTime",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "firstInstanceStartTime",
                                                                                                                    "plural": false,
                                                                                                                    "selections": (v22 /*: any*/),
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v20 /*: any*/),
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "IntervalDefinition",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "interval",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "interval",
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "byDay",
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "bySetPos",
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "freqType",
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "count",
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "EventTime",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "untilTime",
                                                                                                                            "plural": false,
                                                                                                                            "selections": (v22 /*: any*/),
                                                                                                                            "storageKey": null
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v23 /*: any*/),
                                                                                                        (v24 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SuggestionResultMeetingNotOnAutopilotPayload",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Event",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "targetEvent",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v15 /*: any*/),
                                                                                                        (v25 /*: any*/),
                                                                                                        (v26 /*: any*/),
                                                                                                        (v23 /*: any*/),
                                                                                                        (v24 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Event",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "conflictingEvent",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v15 /*: any*/),
                                                                                                        (v26 /*: any*/),
                                                                                                        (v25 /*: any*/),
                                                                                                        (v23 /*: any*/),
                                                                                                        (v24 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SuggestionResultConflictingMeetingPayload",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "focusMinutesCost",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Event",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "targetEvent",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v15 /*: any*/),
                                                                                                        (v27 /*: any*/),
                                                                                                        (v25 /*: any*/),
                                                                                                        (v26 /*: any*/),
                                                                                                        (v23 /*: any*/),
                                                                                                        (v24 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SuggestionResultExpensiveMeetingPayload",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "approximateMonthlyFocusHoursCost",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v28 /*: any*/)
                                                                                            ],
                                                                                            "type": "SuggestionResultExpensiveOrganizerPayload",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                (v28 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "totalFocusTimeMinutes",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "totalMinutes",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "week",
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SuggestionResultLowFocusTimePayload",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                (v28 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "minDate",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "maxDate",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Event",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "targetEvent",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v15 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SuggestionResultTeammateOutOfOfficePayload",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "RewindHistory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "rewindHistory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v2 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "snapshotDurationMillis",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "CompactCalendarSlotSnapshot",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "snapshots",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "snapshotMillis",
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "DaySnapshot",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "days",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "SnapshotBits",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "workingHours",
                                                                                                                            "plural": false,
                                                                                                                            "selections": (v29 /*: any*/),
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "SnapshotBits",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "meetings",
                                                                                                                            "plural": false,
                                                                                                                            "selections": (v29 /*: any*/),
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "SnapshotBits",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "focusTime",
                                                                                                                            "plural": false,
                                                                                                                            "selections": (v29 /*: any*/),
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "SnapshotBits",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "lunch",
                                                                                                                            "plural": false,
                                                                                                                            "selections": (v29 /*: any*/),
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "SnapshotBits",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fragmented",
                                                                                                                            "plural": false,
                                                                                                                            "selections": (v29 /*: any*/),
                                                                                                                            "storageKey": null
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "rewindWeek",
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SuggestionResultWeekInReviewPayload",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "HistoricalDefragBenefitScore",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "historicalDefragBenefitScore",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "totalFocusTimeSavings",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "conflictsResolved",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "affectedCalendars",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "meetingsMoved",
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "dateRangeMin",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "dateRangeMax",
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SuggestionResultWeeklyAutopilotSummaryPayload",
                                                                                            "abstractKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SuggestionActionResult",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "primaryAction",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "display",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isPrimary",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v18 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": null,
                                                                                            "kind": "LinkedField",
                                                                                            "name": "payload",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v3 /*: any*/),
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        (v30 /*: any*/),
                                                                                                        (v28 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "hasRoom",
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "SuggestionActionAutopilotPayload",
                                                                                                    "abstractKey": null
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "configureSettingsType",
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "SuggestionActionConfigureSettingsPayload",
                                                                                                    "abstractKey": null
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": (v31 /*: any*/),
                                                                                                    "type": "SuggestionActionDeclinePayload",
                                                                                                    "abstractKey": null
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": (v31 /*: any*/),
                                                                                                    "type": "SuggestionActionFyiPayload",
                                                                                                    "abstractKey": null
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        (v28 /*: any*/)
                                                                                                    ],
                                                                                                    "type": "SuggestionActionInvitePayload",
                                                                                                    "abstractKey": null
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": (v31 /*: any*/),
                                                                                                    "type": "SuggestionActionRemoveAttendeePayload",
                                                                                                    "abstractKey": null
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        (v33 /*: any*/),
                                                                                                        (v34 /*: any*/)
                                                                                                    ],
                                                                                                    "type": "SuggestionActionRequestToMovePayload",
                                                                                                    "abstractKey": null
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        (v28 /*: any*/),
                                                                                                        (v30 /*: any*/),
                                                                                                        (v33 /*: any*/),
                                                                                                        (v34 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "eventStartWeek",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "Event",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "event",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                (v27 /*: any*/),
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isAllDay",
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "EventKey",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "eventKey",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v30 /*: any*/),
                                                                                                                        (v2 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "EventTime",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "startTime",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v21 /*: any*/),
                                                                                                                        (v19 /*: any*/),
                                                                                                                        (v20 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "EventTime",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "endTime",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v21 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v15 /*: any*/),
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Attendee",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "attendees",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        (v17 /*: any*/),
                                                                                                                        (v16 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v25 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "SuggestionActionReschedulePayload",
                                                                                                    "abstractKey": null
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        (v30 /*: any*/),
                                                                                                        (v28 /*: any*/)
                                                                                                    ],
                                                                                                    "type": "SuggestionActionViewMeetingPayload",
                                                                                                    "abstractKey": null
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        (v28 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "viewWeek",
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "SuggestionActionViewProfilePayload",
                                                                                                    "abstractKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "suggestionId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "FeedSuggestionText",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "text",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v15 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "subHeading",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "FeedSuggestionResults",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v2 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "e2102c4e2d5699413143e6f23f5cfdc0",
            "id": null,
            "metadata": {},
            "name": "SuggestionsFeedRendererQuery",
            "operationKind": "query",
            "text": "query SuggestionsFeedRendererQuery(\n  $debugFetchDate: BigInt\n) {\n  viewer {\n    ...SuggestionsFeed_viewer_2ILGSp\n    id\n  }\n}\n\nfragment AvatarPerson_org on Org {\n  id\n}\n\nfragment AvatarPerson_person on Person {\n  __typename\n  id\n  emails\n  primaryEmail\n  isYou\n  userId\n  isUser\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n}\n\nfragment AvatarRow_org on Org {\n  ...AvatarPerson_org\n}\n\nfragment AvatarRow_personList on PersonList {\n  list {\n    ...AvatarPerson_person\n    primaryEmail\n    id\n  }\n}\n\nfragment SuggestionActionAutopilot_org on Org {\n  id\n}\n\nfragment SuggestionActionAutopilot_payload on SuggestionActionAutopilotPayload {\n  externalEventId\n  calendarId\n  hasRoom\n}\n\nfragment SuggestionActionColors_org on Org {\n  id\n  primaryOrgCalendar\n  eventColoringSettingsErrorable {\n    __typename\n    ... on EventColoringSettings {\n      eventCategoryColorings {\n        eventCategory\n        googleColorKey\n        active\n        isUserSet\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment SuggestionActionConfigSettings_org on Org {\n  ...SuggestionActionColors_org\n  ...SuggestionActionSlack_org\n  ...SuggestionActionTravelTime_org\n}\n\nfragment SuggestionActionConfigSettings_payload on SuggestionActionConfigureSettingsPayload {\n  configureSettingsType\n}\n\nfragment SuggestionActionDecline_payload on SuggestionActionDeclinePayload {\n  nop\n}\n\nfragment SuggestionActionFyi_payload on SuggestionActionFyiPayload {\n  nop\n}\n\nfragment SuggestionActionInvite_org on Org {\n  id\n}\n\nfragment SuggestionActionInvite_payload on SuggestionActionInvitePayload {\n  calendarId\n}\n\nfragment SuggestionActionRemoveAttendee_payload on SuggestionActionRemoveAttendeePayload {\n  nop\n}\n\nfragment SuggestionActionRequestToMove_payload on SuggestionActionRequestToMovePayload {\n  betterTime {\n    date\n    timeSlot\n  }\n  nearestAlternateTime {\n    date\n    timeSlot\n  }\n}\n\nfragment SuggestionActionReschedule_payload on SuggestionActionReschedulePayload {\n  calendarId\n  externalEventId\n  betterTime {\n    date\n    timeSlot\n  }\n  nearestAlternateTime {\n    date\n    timeSlot\n  }\n  eventStartWeek\n  event {\n    calendarIds\n    isAllDay\n    eventKey {\n      externalEventId\n      id\n    }\n    startTime {\n      millis\n      dateOrDateTime\n      timeZone\n    }\n    endTime {\n      millis\n    }\n    title\n    attendees {\n      displayName\n      urnValue\n    }\n    organizer {\n      urnValue\n    }\n  }\n}\n\nfragment SuggestionActionSlack_org on Org {\n  id\n  slackAccountsErrorable {\n    __typename\n    ... on SlackAccountList {\n      list {\n        slackTeamId\n        slackUserId\n        teamDisplayName\n        id\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  slackSettingsErrorable {\n    __typename\n    ... on SlackSettingsList {\n      list {\n        id\n        slackTeamId\n        slackUserId\n        calendarStatus {\n          calendarStatusEnabled\n          includeMeetingCategory\n          includeMeetingTitle\n        }\n        dailyDigestSettings {\n          enabled\n          timeSlot\n        }\n        dndSettings {\n          focusTime\n          meeting\n        }\n        notificationSettings {\n          defragSummary\n        }\n        calendarStatusEnabled\n        includeMeetingCategory\n        includeMeetingTitle\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment SuggestionActionTravelTime_org on Org {\n  id\n  workAddressForUser {\n    __typename\n    ... on Address {\n      rawAddress\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n}\n\nfragment SuggestionActionViewMeeting_payload on SuggestionActionViewMeetingPayload {\n  externalEventId\n  calendarId\n}\n\nfragment SuggestionActionViewProfile_payload on SuggestionActionViewProfilePayload {\n  calendarId\n  viewWeek\n}\n\nfragment SuggestionActionViewTeamDashboard_payload on SuggestionActionViewTeamDashboardPayload {\n  __typename\n}\n\nfragment SuggestionAction_feedSuggestion on FeedSuggestion {\n  id\n  suggestionPayload {\n    __typename\n    ... on SuggestionResultChromeExtensionTipPayload {\n      tipType\n    }\n    ... on SuggestionResultMissingUserConfigurationPayload {\n      configurationType\n    }\n  }\n  primaryAction {\n    display\n    isPrimary\n    type\n    payload {\n      __typename\n      ... on SuggestionActionAutopilotPayload {\n        ...SuggestionActionAutopilot_payload\n      }\n      ... on SuggestionActionConfigureSettingsPayload {\n        ...SuggestionActionConfigSettings_payload\n      }\n      ... on SuggestionActionDeclinePayload {\n        ...SuggestionActionDecline_payload\n      }\n      ... on SuggestionActionFyiPayload {\n        ...SuggestionActionFyi_payload\n      }\n      ... on SuggestionActionInvitePayload {\n        ...SuggestionActionInvite_payload\n      }\n      ... on SuggestionActionRemoveAttendeePayload {\n        ...SuggestionActionRemoveAttendee_payload\n      }\n      ... on SuggestionActionRequestToMovePayload {\n        ...SuggestionActionRequestToMove_payload\n      }\n      ... on SuggestionActionReschedulePayload {\n        ...SuggestionActionReschedule_payload\n      }\n      ... on SuggestionActionViewMeetingPayload {\n        ...SuggestionActionViewMeeting_payload\n      }\n      ... on SuggestionActionViewProfilePayload {\n        ...SuggestionActionViewProfile_payload\n      }\n      ... on SuggestionActionViewTeamDashboardPayload {\n        ...SuggestionActionViewTeamDashboard_payload\n      }\n    }\n  }\n}\n\nfragment SuggestionAction_org on Org {\n  ...SuggestionActionInvite_org\n  ...SuggestionActionAutopilot_org\n  ...SuggestionActionConfigSettings_org\n  experiments\n}\n\nfragment SuggestionBodyAutopilot_org on Org {\n  ...AvatarPerson_org\n  id\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        ...AvatarPerson_person\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment SuggestionBodyAutopilot_suggestionPayload on SuggestionResultPayload {\n  __isSuggestionResultPayload: __typename\n  ... on SuggestionResultMeetingNotOnAutopilotPayload {\n    targetEvent {\n      title\n      attendees {\n        urnValue\n        displayName\n      }\n      recurrenceRules {\n        firstInstanceStartTime {\n          type\n          dateOrDateTime\n          timeZone\n          millis\n          offsetMinutes\n        }\n        timeZone\n        interval {\n          interval\n          byDay\n          bySetPos\n          freqType\n          count\n          untilTime {\n            type\n            dateOrDateTime\n            timeZone\n            millis\n            offsetMinutes\n          }\n        }\n      }\n      startTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n      endTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n}\n\nfragment SuggestionBodyConfigColors_org on Org {\n  eventColoringSettingsErrorable {\n    __typename\n    ... on EventColoringSettings {\n      eventCategoryColorings {\n        googleColorKey\n        eventCategory\n        active\n        isUserSet\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment SuggestionBodyConflictingMeeting_org on Org {\n  id\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment SuggestionBodyConflictingMeeting_suggestionPayload on SuggestionResultPayload {\n  __isSuggestionResultPayload: __typename\n  ... on SuggestionResultConflictingMeetingPayload {\n    targetEvent {\n      title\n      organizer {\n        urnValue\n      }\n      createdMillis\n      startTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n      endTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n    conflictingEvent {\n      title\n      createdMillis\n      organizer {\n        urnValue\n      }\n      startTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n      endTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n}\n\nfragment SuggestionBodyExpensiveMeeting_org on Org {\n  ...AvatarRow_org\n  id\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      ...AvatarRow_personList\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment SuggestionBodyExpensiveMeeting_suggestionPayload on SuggestionResultPayload {\n  __isSuggestionResultPayload: __typename\n  ... on SuggestionResultExpensiveMeetingPayload {\n    focusMinutesCost\n    targetEvent {\n      title\n      calendarIds\n      organizer {\n        urnValue\n      }\n      createdMillis\n      startTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n      endTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n}\n\nfragment SuggestionBodyExpensiveOrganizer_org on Org {\n  ...AvatarPerson_org\n  id\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        ...AvatarPerson_person\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment SuggestionBodyExpensiveOrganizer_suggestionPayload on SuggestionResultPayload {\n  __isSuggestionResultPayload: __typename\n  ... on SuggestionResultExpensiveOrganizerPayload {\n    approximateMonthlyFocusHoursCost\n    calendarId\n  }\n}\n\nfragment SuggestionBodyLowFocusTime_org on Org {\n  ...AvatarPerson_org\n  id\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        ...AvatarPerson_person\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment SuggestionBodyLowFocusTime_suggestionPayload on SuggestionResultLowFocusTimePayload {\n  calendarId\n  totalFocusTimeMinutes\n  totalMinutes\n  week\n}\n\nfragment SuggestionBodyOutOfOffice_org on Org {\n  id\n  ...AvatarPerson_org\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        ...AvatarPerson_person\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment SuggestionBodyOutOfOffice_suggestionPayload on SuggestionResultPayload {\n  __isSuggestionResultPayload: __typename\n  ... on SuggestionResultTeammateOutOfOfficePayload {\n    calendarId\n    minDate\n    maxDate\n    targetEvent {\n      title\n    }\n  }\n}\n\nfragment SuggestionBodyWeekInReview_suggestionPayload on SuggestionResultPayload {\n  __isSuggestionResultPayload: __typename\n  ... on SuggestionResultWeekInReviewPayload {\n    rewindHistory {\n      ...WeekInReviewScrubber_rewindHistory\n      id\n    }\n    rewindWeek\n  }\n}\n\nfragment SuggestionBodyWeeklyAutopilotSummary_org on Org {\n  ...AvatarRow_org\n  id\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      ...AvatarRow_personList\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment SuggestionBodyWeeklyAutopilotSummary_suggestionPayload on SuggestionResultPayload {\n  __isSuggestionResultPayload: __typename\n  ... on SuggestionResultWeeklyAutopilotSummaryPayload {\n    historicalDefragBenefitScore {\n      totalFocusTimeSavings\n      conflictsResolved\n      affectedCalendars\n      meetingsMoved\n    }\n    dateRangeMin\n    dateRangeMax\n  }\n}\n\nfragment SuggestionBody_org on Org {\n  ...SuggestionBodyAutopilot_org\n  ...SuggestionBodyConfigColors_org\n  ...SuggestionBodyConflictingMeeting_org\n  ...SuggestionBodyExpensiveMeeting_org\n  ...SuggestionBodyExpensiveOrganizer_org\n  ...SuggestionBodyLowFocusTime_org\n  ...SuggestionBodyOutOfOffice_org\n  ...SuggestionBodyWeeklyAutopilotSummary_org\n}\n\nfragment SuggestionBody_suggestionPayload on SuggestionResultPayload {\n  __isSuggestionResultPayload: __typename\n  __typename\n  ...SuggestionBodyAutopilot_suggestionPayload\n  ...SuggestionBodyConflictingMeeting_suggestionPayload\n  ...SuggestionBodyExpensiveMeeting_suggestionPayload\n  ...SuggestionBodyExpensiveOrganizer_suggestionPayload\n  ...SuggestionBodyLowFocusTime_suggestionPayload\n  ...SuggestionBodyOutOfOffice_suggestionPayload\n  ...SuggestionBodyWeekInReview_suggestionPayload\n  ...SuggestionBodyWeeklyAutopilotSummary_suggestionPayload\n  ... on SuggestionResultChromeExtensionTipPayload {\n    tipType\n  }\n  ... on SuggestionResultMissingUserConfigurationPayload {\n    configurationType\n  }\n}\n\nfragment SuggestionCardHeader_feedSuggestion on FeedSuggestion {\n  occurredMillis\n  suggestionId\n  suggestionType\n  text {\n    title\n    subHeading\n  }\n  suggestionPayload {\n    __typename\n    ... on SuggestionResultChromeExtensionTipPayload {\n      tipType\n    }\n    ... on SuggestionResultMissingUserConfigurationPayload {\n      configurationType\n    }\n  }\n}\n\nfragment SuggestionCardHeader_org on Org {\n  experiments\n  primaryTeam {\n    __typename\n    ... on Team {\n      teamName\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment SuggestionCard_feedSuggestion on FeedSuggestion {\n  ...SuggestionAction_feedSuggestion\n  ...SuggestionCardHeader_feedSuggestion\n  id\n  suggestionId\n  suggestionType\n  suggestionPayload {\n    ...SuggestionBody_suggestionPayload\n    __typename\n    ... on SuggestionResultChromeExtensionTipPayload {\n      tipType\n    }\n    ... on SuggestionResultMissingUserConfigurationPayload {\n      configurationType\n    }\n  }\n  primaryAction {\n    type\n  }\n}\n\nfragment SuggestionCard_org on Org {\n  ...SuggestionAction_org\n  ...SuggestionBody_org\n  ...SuggestionCardHeader_org\n}\n\nfragment SuggestionsFeed_viewer_2ILGSp on Viewer {\n  user {\n    orgs(first: 1000000) {\n      edges {\n        node {\n          ...SuggestionCard_org\n          experiments\n          feedSuggestionsErrorable(debugFetchDate: $debugFetchDate) {\n            __typename\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on FeedSuggestionResults {\n              suggestions {\n                id\n                occurredMillis\n                suggestionType\n                ...SuggestionCard_feedSuggestion\n                suggestionPayload {\n                  __typename\n                  ... on SuggestionResultChromeExtensionTipPayload {\n                    tipType\n                  }\n                  ... on SuggestionResultMissingUserConfigurationPayload {\n                    configurationType\n                  }\n                }\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment WeekInReviewScrubber_rewindHistory on RewindHistory {\n  id\n  snapshotDurationMillis\n  snapshots {\n    snapshotMillis\n    days {\n      workingHours {\n        amBits\n        pmBits\n      }\n      meetings {\n        amBits\n        pmBits\n      }\n      focusTime {\n        amBits\n        pmBits\n      }\n      lunch {\n        amBits\n        pmBits\n      }\n      fragmented {\n        amBits\n        pmBits\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '2a39e5e368ce3ec366c1d8ca973ce93e';
export default node;
